import { Access } from '../lib'
import { ERoleAccess } from '../types'
import { ALL_LANG_KEY } from '../types/lang'

type IMenuRecord = {
	title: string
	url: string
	access: ($access: Access) => boolean
}

type IMenuKey =
	| 'affiliate'
	| 'offerScope'
	| 'offerSpend'
	| 'offerSpendReport'
	| 'offerSpendReportByAccount'
	| 'offerSpendReportByOffer'
	| 'offerSpendReportByOfferScope'
	| 'postbackSend'
	| 'revenueAgency'
	| 'revenueSpend'
	| 'revenueSpendReportByAccount'
	| 'revenueSpendReportByTeam'
	| 'account'
	| 'role'
	| 'job'
	| 'project'
	| 'login'
	| 'logout'

export const MENU: Record<IMenuKey, IMenuRecord> = {
	offerScope: {
		title: ALL_LANG_KEY.side_menu.offer_scope_title,
		url: '/offer/scope',
		access: ($access) => !!$access.$(ERoleAccess.OfferScopeList)
	},
	offerSpend: {
		title: ALL_LANG_KEY.side_menu.offer_spend_title,
		url: '/offer/spend',
		access: ($access) => !!$access.$(ERoleAccess.OfferSpendList)
	},
	offerSpendReport: {
		title: ALL_LANG_KEY.side_menu.offer_spend_report_title,
		url: '/offer/spend/by',
		access: ($access) => (
			!!$access.$(ERoleAccess.OfferSpendByAccountList) ||
			!!$access.$(ERoleAccess.OfferSpendByOfferList) ||
			!!$access.$(ERoleAccess.OfferSpendByOfferScopeList)
		)
	},
	offerSpendReportByAccount: {
		title: ALL_LANG_KEY.side_menu.offer_spend_report_by_account_title,
		url: '/offer/spend/byAccount',
		access: ($access) => !!$access.$(ERoleAccess.OfferSpendByAccountList)
	},
	offerSpendReportByOffer: {
		title: ALL_LANG_KEY.side_menu.offer_spend_report_by_offer_title,
		url: '/offer/spend/byOffer',
		access: ($access) => !!$access.$(ERoleAccess.OfferSpendByOfferList)
	},
	offerSpendReportByOfferScope: {
		title: ALL_LANG_KEY.side_menu.offer_spend_report_by_offer_scope_title,
		url: '/offer/spend/byOfferScope',
		access: ($access) => !!$access.$(ERoleAccess.OfferSpendByOfferScopeList)
	},
	postbackSend: {
		title: ALL_LANG_KEY.side_menu.postback_send_title,
		url: '/postback/send',
		access: ($access) => !!$access.$(ERoleAccess.ApiPostbackSend)
	},
	revenueAgency: {
		title: ALL_LANG_KEY.side_menu.revenue_agency_title,
		url: '/revenue/agency',
		access: ($access) => !!$access.$(ERoleAccess.RevenueAgencyList)
	},
	affiliate: {
		title: ALL_LANG_KEY.side_menu.affiliate_title,
		url: '/revenue/affiliate',
		access: ($access) => !!$access.$(ERoleAccess.AffiliateList)
	},
	revenueSpend: {
		title: ALL_LANG_KEY.side_menu.revenue_spend_title,
		url: '/revenue/spend',
		access: ($access) => !!$access.$(ERoleAccess.RevenueSpendList)
	},
	revenueSpendReportByAccount: {
		title: ALL_LANG_KEY.side_menu.revenue_spend_report_by_account_title,
		url: '/revenue/spend/byAccount',
		access: ($access) => !!$access.$(ERoleAccess.RevenueSpendByAccountList)
	},
	revenueSpendReportByTeam: {
		title: ALL_LANG_KEY.side_menu.revenue_spend_report_by_team_title,
		url: '/revenue/spend/byTeam',
		access: ($access) => !!$access.$(ERoleAccess.RevenueSpendByTeamList)
	},
	account: {
		title: ALL_LANG_KEY.side_menu.account_title,
		url: '/account',
		access: ($access) => !!$access.$(ERoleAccess.AccountList)
	},
	role: {
		title: ALL_LANG_KEY.side_menu.role_title,
		url: '/role',
		access: ($access) => !!$access.$(ERoleAccess.RoleList)
	},
	//TODO: check the place in MENU_CATEGORY structure
	job: {
		title: ALL_LANG_KEY.side_menu.job_title,
		url: '/job',
		access: ($access) => !!$access.$(ERoleAccess.JobList)
	},
	//TODO: check the place in MENU_CATEGORY structure
	project: {
		title: ALL_LANG_KEY.side_menu.project_title,
		url: '/project',
		access: ($access) => !!$access.$(ERoleAccess.ProjectList)
	},
	login: {
		title: ALL_LANG_KEY.side_menu.login_title,
		url: '/login',
		access: ($access) => true // all have access
	},
	logout: {
		title: ALL_LANG_KEY.side_menu.logout_title,
		url: '/login',
		access: ($access) => true // all have access
	}
}

type IMenuCategoryRecord = {
	title: string
	access: ($access: Access) => boolean
}

type IMenuCategoryKey = 'affiliate' | 'revenue' | 'profile'

export const MENU_CATEGORY: Record<IMenuCategoryKey, IMenuCategoryRecord> = {
	affiliate: {
		title: ALL_LANG_KEY.side_menu_category.affiliate_title,
		access: ($access) => (
			MENU.offerScope.access($access) ||
			MENU.offerSpend.access($access) ||
			MENU.offerSpendReport.access($access) ||
			MENU.postbackSend.access($access)
		)
	},
	revenue: {
		title: ALL_LANG_KEY.side_menu_category.revenue_title,
		access: ($access) => (
			MENU.revenueAgency.access($access) ||
			MENU.revenueSpend.access($access) ||
			MENU.affiliate.access($access) ||
			MENU.revenueSpendReportByAccount.access($access) ||
			MENU.revenueSpendReportByTeam.access($access)
		)
	},
	profile: {
		title: ALL_LANG_KEY.side_menu_category.profile_title,
		access: ($access) => (
			MENU.account.access($access) ||
			MENU.role.access($access) ||
			MENU.logout.access($access)
		)
	}
}